package horcrux.frontend.common.views.chat

import horcrux.common.utils.safelet.safeLet
import horcrux.common.utils.toOptional
import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.configs.StaticContentConfigs
import horcrux.frontend.common.views.components.input.InstructionsWithHelp
import js.objects.jso
import mui.material.Container
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.h1
import react.useEffect
import react.useRef
import web.cssom.AlignItems
import web.cssom.JustifyContent
import web.cssom.pt
import web.html.HTMLElement
import web.html.HTMLInputElement
import web.scroll.ScrollBehavior
import web.scroll.ScrollLogicalPosition

external interface ChatContainerProps : Props {
    var globalAppState: GlobalAppState
}

val ChatContainer = FC<ChatContainerProps> { props ->
    val chatMessageDataList = props.globalAppState.currentChatMessageDataList
    val isLoading = props.globalAppState.submitMessageIconIsLoadingState.get()
    val shouldShowCollectionNavigator = props.globalAppState.shouldShowCollectionNavigatorState.get()
    val marginTop = 55.pt
    val marginBottom = 50.pt

    // Scroll to bottom of box when new entry is added to chatMessageDataList
    val chatBoxRef = useRef<HTMLElement>()
    useEffect(shouldShowCollectionNavigator, isLoading, chatMessageDataList) {
        safeLet(
            shouldShowCollectionNavigator.not().toOptional(),
            chatBoxRef.current
        ) { _, current ->
            current.scrollIntoView(jso {
                this.behavior = ScrollBehavior.smooth
                this.block = ScrollLogicalPosition.end
            })
            props.globalAppState.inputPromptRef.focus()
        }
    }
    Container {
        this.ref = chatBoxRef
        if (chatMessageDataList.isEmpty()) {
            InstructionsWithHelp {
                this.id = "empty-chat-message"
                this.instructions = "Send a Message to Start Learning About Your Collection"
                this.helpText =
                    "You can use this screen to send messages to The Grok App, which will use the information in your collection to generate its responses."
                this.textTagSupplierMaybe = { h1 }
                this.sx {
                    this.marginTop = 275.pt
                    this.justifyContent = JustifyContent.center
                }
            }
        }

        chatMessageDataList.withIndex().forEach {
            val chatMessageData = it.value
            ChatMessage {
                this.chatMessageData = chatMessageData
                this.globalAppState = props.globalAppState
                this.sx {
                    this.marginTop = if (it.index == 0) marginTop else 10.pt
                    this.marginBottom =
                        if ((it.index == chatMessageDataList.size - 1) && !isLoading) marginBottom else 10.pt
                }
            }
        }
        if (isLoading) {
            LoadingMessage {
                this.sx {
                    this.marginTop = 30.pt
                    this.marginBottom = marginBottom
                    this.justifyContent = JustifyContent.center
                    this.alignItems = AlignItems.center
                    this.color = StaticContentConfigs.BLUE
                }
            }
        }
        InputChatPrompt {
            this.globalAppState = props.globalAppState
        }
    }
}
